/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Settings_Fields_App_NameInputs */

const en_admin_settings_fields_app_name = /** @type {(inputs: Admin_Settings_Fields_App_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`App Name`)
};

/**
* | output |
* | --- |
* | "App Name" |
*
* @param {Admin_Settings_Fields_App_NameInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const admin_settings_fields_app_name = /** @type {((inputs?: Admin_Settings_Fields_App_NameInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Settings_Fields_App_NameInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_admin_settings_fields_app_name(inputs)
});
export { admin_settings_fields_app_name as "admin.settings.fields.app_name" }